export default __webpack_public_path__ + "static/media/site.98cd86a6.png";